const localeFormats = ['number', 'currency', 'percent'];

export function isLocaleFormat(localeFormat) {
  return localeFormats.includes(localeFormat);
}
